<template>
  <div id="myPaymentResources">
    <h2 class="section-title">My Payment Sources</h2>
    <div class="row">
      <div class="col-md-8">
        <div class="payment-sources" v-if="sources.length">
          <div class="source" v-for="source in sources">
            <div class="card-logo">
              <img src="../../assets/img/cards/visa.png"/>
            </div>
            <div class="card-numbers">
              <div class="text-muted">Card Number</div>
              <span>****</span>
              <span>****</span>
              <span>****</span>
              <span>{{ source.last4 }}</span>
            </div>
            <div class="card-year">
              <div class="text-muted">Expire Year</div>
              {{ source.exp_year }}
            </div>
            <div class="btn btn-danger btn-sm delete-card" @click="deletePaymentSource()">×</div>
          </div>
        </div>
        <div v-else>
          <p class="alert alert-warning">
            You have no stored cards.<br>
            Place an order and select <u>Store card for future orders</u>.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'

  let kf

  export default {
    name: 'my-payment-sources',
    computed: {
      ...mapState({
        location: state => state.location
      })
    },
    data () {
      return {
        sources: []
      }
    },
    created () {
      kf = this

      kf.$store.dispatch('GetCustomerPaymentSources', kf.location.id)
        .then(response => {
          kf.sources = response.sources
        })
        .catch(error => {
          console.log(error)
        })
    },
    methods: {
      deletePaymentSource () {
        if (confirm('Are you sure you want to delete this payment card?')) {
          kf.$store.dispatch('DeleteCustomerDefaultPaymentSource', kf.location.id)
            .then(() => {
              kf.sources = []
            })
            .catch(error => {
              console.log(error)
              kf.notifyVue('error', error)
            })
        }
      },
      notifyVue (type, message) {
        this.$notifications.notify({
          message: message,
          icon: '',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: type
        })
      }
    }
  }

</script>



// WEBPACK FOOTER //
// my-payment-sources.vue?4ce548cb